function LegendSeg({ className }: { className: string }) {
  return <span className={`charger-seg ${className}`} aria-hidden />;
}

export function ChargerLegend() {
  return (
    <div
      className="flex flex-wrap items-center gap-x-3 gap-y-1 text-text-secondary"
      style={{ fontSize: "var(--font-micro)" }}
    >
      <span className="inline-flex items-center gap-1">
        <LegendSeg className="charger-seg--health-ok" />
        Health
      </span>
      <span className="inline-flex items-center gap-1">
        <LegendSeg className="charger-seg--alloc-on" />
        MV5
      </span>
      <span className="inline-flex items-center gap-1">
        <LegendSeg className="charger-seg--activ-on" />
        LB
      </span>
      <span className="inline-flex items-center gap-1">
        <LegendSeg className="charger-seg--sp-on" />
        SP
      </span>
      <span className="inline-flex items-center gap-1">
        <LegendSeg className="charger-seg--resp-on" />
        Resp
      </span>
      <span className="inline-flex items-center gap-1.5 text-text-tertiary">
        ·
        <span className="charger-tile charger-tile--idle charger-tile--legend-free px-1.5 py-0.5" aria-hidden />
        free
        <span className="charger-tile charger-tile--ring-green px-1.5 py-0.5" aria-hidden />
        paused
        <span className="charger-tile charger-tile--ring-blue px-1.5 py-0.5" aria-hidden />
        charging
      </span>
    </div>
  );
}
